import React from 'react'
import { Container } from '@/components/Container'
import { GentlyAppear } from '@/components/GentlyAppear'
import { Jumbotron } from '@/components/Jumbotron'
import './index.css'
import { Header } from '../Header'

type LayoutProps = {
  children?: React.ReactNode
  location: { pathname: string }
}

export const Layout = ({ children, location }: LayoutProps) => {
  return (
    <div className="Layout--root" id="outer-container">
      <Header />
      <Jumbotron />
      <Container className="Layout--container">
        <GentlyAppear>{children}</GentlyAppear>
      </Container>
    </div>
  )
}

export default Layout
